export default "__VITE_ASSET__c1b02471__"